import React from 'react';
import { MessagePropertiesContext } from '../../../contexts/messageProperties';
import Modal from '../../../components/modal/rightSlideInModal';
import Styles from './components/styles/styles';
import styles from './modal.module.pcss';

const { manufacturer, name, productDimensionsProductType } = window.globalProductDetails;

function ProductStylesModal(): React.ReactElement {
  const [isModalOpen, setIsModalOpen] = React.useState(false);
  const [formattedMessage] = React.useContext(MessagePropertiesContext);
  const heading = formattedMessage({
    id: `product.other.styles.title.${productDimensionsProductType}`,
    fallback: 'Other Styles'
  });

  const handleClose = (): void => setIsModalOpen(false);
  const handleOpen = (): void => setIsModalOpen(true);

  return (
    <Modal isOpen={isModalOpen} onOpen={handleOpen} onClose={handleClose} heading={heading}>
      <div className={styles['product-styles']}>
        {manufacturer && <h4 className={styles['product-styles__manufacturer']}>{manufacturer}</h4>}
        <h4 className={styles['product-styles__name']}>{name}</h4>
        <Styles />
      </div>
    </Modal>
  );
}

export default ProductStylesModal;
